import VuexPersist from "vuex-persist";

const SENSITIVE_SETTING_KEYS = ["system_config_google_maps_api_key"];

export default new VuexPersist({
  key: "app",
  storage: window.localStorage,
  modules: ["auth", "paginate", "sort", "tableView"],
  reducer: (state: any) => ({
    auth: {
      ...state.auth,
      accessToken: undefined,
      idToken: undefined,
      lastRefreshedAt: null,
      user: state.auth.user
        ? {
            ...state.auth.user,
            Username: undefined,
          }
        : state.auth.user,
      settings: state.auth.settings ? state.auth.settings.filter((setting: any) => !SENSITIVE_SETTING_KEYS.includes(setting.key)) : state.auth.settings,
    },
    paginate: state.paginate,
    sort: state.sort,
    tableView: state.tableView,
  }),
});
